import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const Stepper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.greyf5};
  height: 6rem;
  border-radius: 6rem 6rem 0 0;
  width: 100%;
  display: flex;
  padding: 0 2.5rem;
  justify-content: center;
  align-items: center;
  @media ${mq(sizes.desktop)} {
    padding: 0 8rem;
    height: 10rem;
  }
`
export const Steps = styled.div`
  width: 100%;
  max-width: 128rem;
  display: flex;
  justify-content: center;
  height: 6px;
  align-items: stretch;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.greyD8};
  border-radius: 3px;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    border-radius: 5px;
    height: 1rem;
  }
`

export const Step = styled.div`
  width: 100%;
  flex-grow: 1;
  position: relative;
  background-color: ${({ theme }) => theme.colors.greenApple};

  .-empty & {
    background-color: transparent;

    &::after {
      box-shadow: none;
      background-color: ${({ theme }) => theme.colors.grey61};
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colors.pureWhite};
    box-shadow: 1px 0 0 1px ${({ theme }) => theme.colors.greenApple};
    border-radius: 50%;
    height: 4px;
    width: 4px;
    @media ${mq(sizes.desktop)} {
      height: 6px;
      width: 6px;
    }
  }
  &.-current ~ & {
    background-color: transparent;
    &::after {
      box-shadow: none;
      background-color: ${({ theme }) => theme.colors.grey61};
    }
  }
`
